module.exports = __webpack_public_path__ + "media/images/hero_images/brand-400-e18516d0a02e32da93ea714b7915db04.jpg";